import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchGet } from '../../../store/fetch';
import { QueryParamsDictionary } from '../../../store/QueryParamsDictionary';
import { EditPanelFilterMultiSelect, ISelectOption } from '../../elements';

export function EditPanelFilterMultiSelectFromEndpoint(props: {
    name: string;
    placeholder?: string | undefined;
    notSelectedText?: string | undefined;
    value: string[] | undefined | null;
    disabled?: boolean | undefined;
    isLoading?: boolean | undefined;
    topLabel?: string | undefined;
    notValid?: boolean | undefined;
    onChange: (value: string[], name: string) => void;
    url: string;
    queryParameters?: QueryParamsDictionary | undefined;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mapResponseToOptions: (response: any) => ISelectOption[];
    isHiddenWhenNoOptions?: boolean;
}) {
    const { url, queryParameters: externalQueryParams, mapResponseToOptions: externalMapResponseToOptions } = props;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const queryParameters = useMemo(() => externalQueryParams, [JSON.stringify(externalQueryParams)]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const mapResponseToOptions = useCallback(externalMapResponseToOptions, [externalMapResponseToOptions.toString()]);

    const [options, setOptions] = useState<ISelectOption[]>([]);
    const [areOptionsLoading, setAreOptionsLoading] = useState<boolean>(true);

    useEffect(() => {
        async function load() {
            const response = await fetchGet(url, queryParameters);

            setOptions(mapResponseToOptions(response));
            setAreOptionsLoading(false);
        }

        void load();
    }, [url, queryParameters, mapResponseToOptions]);

    if (props.isHiddenWhenNoOptions && options.length === 0) {
        return null;
    }

    return (
        <EditPanelFilterMultiSelect
            name={props.name}
            value={props.value ?? []}
            handleChange={props.onChange}
            disabled={props.isLoading ?? areOptionsLoading}
            placeholder={props.placeholder}
            options={options}
        />
    );
}
